













// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

@Component({
  name: 'ChangeEmailFormComponent',
  components: {}
})
export default class ResetPasswordFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public currentEmailAddress: string = null;
  public newEmailAddress: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }
  public clearFields() {
    this.newEmailAddress = null;
  }
  public async onShow(dynamicProps: any) {
    this.clearFields()
    if (dynamicProps && dynamicProps.usernameOrEmail) this.currentEmailAddress = dynamicProps.currentEmailAddress
  }
  public async onOK() {

    // tidy up form fields
    if (this.newEmailAddress) this.newEmailAddress = this.newEmailAddress.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.newEmailAddress || this.newEmailAddress.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter an email address')
    }

    if (abort) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/auth/changeEmail'
      const response: any = await utils.makePostCall(url, { newEmail: this.newEmailAddress } );
      if (!response || !response.data) throw(new Error('ChangeEmailFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user) {
        // success
        this.$store.commit('setLoading', { loading: false });
        this.$emit('close', true)

        const user: TokenUser = new TokenUser(response.data.user)
        globalUC.add(user)      // might as well give cache the very latest one

        utils.toast(this, 'Next Step', `Check your email at ${this.newEmailAddress} for a link to confirm your new email address. The change will not take effect until you confirm the new address.`, 10000)

        // clear out in case they do another
        this.clearFields()
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not process')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)
  }
  
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
